import $ from 'jquery';

$(document).ready(function() {
	
	$('nav a[href*="#"]:not([href="#"])').click(function() {
		var target = $(this.hash);
		$('html,body').stop().animate({
			scrollTop: target.offset().top - 120
		}, 'linear');   
	});    	
});